/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".color-red[_ngcontent-%COMP%]{color:#cd1f1e}.color-green[_ngcontent-%COMP%]{color:#5eba00}\n/*# sourceMappingURL=host-wallet-transactions.component.css.map*/"];
export { styles as styles };
